// extracted by mini-css-extract-plugin
export default {"wrapper":"reg-item-image__wrapper__hge2R","bannerWrapper":"reg-item-image__bannerWrapper__y34PW"};